export default "__VITE_ASSET__BNwZ5KKk__"